import { render, staticRenderFns } from "./Wallboard.vue?vue&type=template&id=cdd335f0"
import script from "./Wallboard.vue?vue&type=script&lang=ts"
export * from "./Wallboard.vue?vue&type=script&lang=ts"
import style0 from "./Wallboard.vue?vue&type=style&index=0&id=cdd335f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports